import { DoOrDumpReportDashboard } from "@/components/dashboard/DoOrDumpReportDashboard";
import type { DoOrDumpDashboardPayload } from "@/types/do-or-dump-dashboard";

/** Static demo shell — same dashboard chrome and numbers as the real report; `preview` skips live narrative generation. */
export function DemoDashboardShell({ payload }: { payload: DoOrDumpDashboardPayload }) {
  return <DoOrDumpReportDashboard payload={payload} preview />;
}
